import React from 'react';
import clsx from 'clsx';
import { colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: colorPalette.grey.light,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    flex: 1,
    position: 'relative',
    zIndex: 0,
  },
}));

export function PageBody({ children, className }: Props): React.ReactElement {
  const classes = useStyles();
  return <div className={clsx(classes.root, className)}>{children}</div>;
}
